import i18n from '@/locales'
import { getEnabledSwitchActions, getSetPublicAction } from '@/utils/common/tableActions'

export default {
  created () {
    this.singleActions = [
      {
        label: i18n.t('table.action.modify'),
        permission: 'ext_resource_types_perform_set_attributes',
        action: (obj) => {
          this.$router.push({
            name: 'ResourceTypeSettingCreate',
            params: {
              attributes: obj.attributes || [],
              ...obj,
              category: obj.type,
              type: 'edit',
            },
          })
        },
      },
      {
        label: i18n.t('common.more'),
        actions: (obj) => {
          return [
            {
              label: i18n.t('table.action.clone'),
              permission: 'ext_resource_types_create',
              action: () => {
                this.$router.push({
                  name: 'ResourceTypeSettingCreate',
                  params: {
                    type: 'clone',
                    name: obj.name,
                    id: obj.id,
                    attributes: obj.attributes || [],
                    category: obj.type,
                  },
                })
              },
            },
            // 启用禁用
            ...getEnabledSwitchActions(this, obj, ['ext_resource_types_perform_enable', 'ext_resource_types_perform_disable'], {
              metas: [
                () => {
                  const ret = {
                    validate: !obj.enabled,
                  }
                  return ret
                },
                () => {
                  const ret = {
                    validate: obj.enabled,
                  }
                  return ret
                },
              ],
              resourceName: this.$t('report.resource_type'),
              fields: ['name', 'enabled', 'created_at'],
            }),
            getSetPublicAction(this, {
              name: this.$t('report.resource_type'),
              scope: 'project',
              resource: 'ext_resource_types',
            }, {
              permission: 'ext_resource_typess_perform_public',
            }),
            {
              label: i18n.t('common.action.delete'),
              permission: 'ext_resource_types_delete',
              action: () => {
                this.createDialog('DeleteResDialog', {
                  name: i18n.t('report.resource_type'),
                  title: i18n.t('common.action.delete'),
                  vm: this,
                  data: [obj],
                  columns: this.columns,
                  onManager: this.onManager,
                })
              },
              meta: (obj) => {
                return {
                  validate: !obj.enabled,
                  tooltip: obj.enabled ? i18n.t('report.not_delete_enable_resource') : '',
                }
              },
            },
          ]
        },
      },
    ]
  },
  methods: {
  },
}
